import {
  FETCH_BONUS_BALANCE_START,
  FETCH_BONUS_BALANCE_SUCCESS,
  FETCH_BONUS_BALANCE_FAIL,
  FETCH_BONUS_HISTORY_START,
  FETCH_BONUS_HISTORY_SUCCESS,
  FETCH_BONUS_HISTORY_FAIL,
  ADJUST_BONUS_BALANCE_START,
  ADJUST_BONUS_BALANCE_SUCCESS,
  ADJUST_BONUS_BALANCE_FAIL,
  CLEAR_BONUS_BALANCE,
} from './action';

const initialState = {
  balance: null,
  isBalanceLoading: false,
  history: {
    items: [],
    total: 0,
  },
  isHistoryLoading: false,
  isInitial: false,
  isAdjusting: false,
  err: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case FETCH_BONUS_BALANCE_START:
    return { ...state, isBalanceLoading: true };
  case FETCH_BONUS_BALANCE_SUCCESS:
    return { ...state, balance: payload.balance, isBalanceLoading: false };
  case FETCH_BONUS_BALANCE_FAIL:
    return { ...state, isBalanceLoading: false, err: payload };

  case FETCH_BONUS_HISTORY_START:
    return { ...state, isHistoryLoading: true };
  case FETCH_BONUS_HISTORY_SUCCESS:
    return {
      ...state,
      history: {
        items: payload.append
          ? [...state.history.items, ...(payload.items || [])]
          : (payload.items || []),
        total: payload.total || 0,
      },
      isHistoryLoading: false,
      isInitial: true,
    };
  case FETCH_BONUS_HISTORY_FAIL:
    return { ...state, isHistoryLoading: false, err: payload };

  case ADJUST_BONUS_BALANCE_START:
    return { ...state, isAdjusting: true };
  case ADJUST_BONUS_BALANCE_SUCCESS:
    return { ...state, isAdjusting: false };
  case ADJUST_BONUS_BALANCE_FAIL:
    return { ...state, isAdjusting: false, err: payload };

  case CLEAR_BONUS_BALANCE:
    return { ...initialState };

  default:
    return state;
  }
};
